import  React, { useState } from 'react'
import InputDate from '../InputDate/InputDate'
import { IcaAlertMessage } from '../IcaElements/IcaAlertMessage'
import { formatDateToYMD } from '../../utils/dateUtils'
import './InputDateRange.scss'
import { useDeviceContext } from '../../contexts/device-context'

export interface InputDateRangeData {
  from: Date
  to: Date
}

export interface InputDateRangeProps {
  onFromChange: (from: Date) => void
  onToChange: (to: Date) => void
  defaultDateRange?: InputDateRangeData | null
}

export default function InputDateRange ({ onFromChange, onToChange, defaultDateRange = null }: InputDateRangeProps) {
  const getTimeString = (date: Date) => date.toTimeString().substring(0,5)
  const [fromDate, setFromDate] = useState(defaultDateRange?.from ? defaultDateRange.from : new Date())
  const [toDate, setToDate] = useState(defaultDateRange?.to ? defaultDateRange.to : new Date())
  const [fromTime, setFromTime] = useState(defaultDateRange?.from ? getTimeString(defaultDateRange.from) : '00:00')
  const [toTime, setToTime] = useState(defaultDateRange?.to ? getTimeString(defaultDateRange.to) : '23:59')
  const { deviceState } = useDeviceContext()
  const hasInitialError = () => {
    if(defaultDateRange?.from && defaultDateRange?.to) {
      const from = defaultDateRange.from.getTime()
      const to = defaultDateRange.to.getTime()
      if (from > to) return true
    }
    return false
  }
  const [validationError, setValidationError] = useState(hasInitialError())

  const validateDateRange = (from: Date, to: Date) => {
    return from.getTime() > to.getTime()
  }

  const handleDateTimeChange = ({ changed, date, time }: {changed: string, date?: string, time?: string }) => {
    let from = fromDate
    let to = toDate
    if (changed === 'from') {
      let dateTimeString = ''
      if(date) dateTimeString = `${date}T${fromTime || '00:00'}`
      if(time) dateTimeString = `${formatDateToYMD(fromDate)}T${time}`
      if(!time && !date) dateTimeString = `${formatDateToYMD(fromDate)}T00:00`

      from = new Date(dateTimeString)
    }
    else if (changed === 'to') {
      let dateTimeString = ''
      if(date) dateTimeString = `${date}T${toTime || '23:59'}`
      if(time) dateTimeString = `${formatDateToYMD(toDate)}T${time}`
      if(!time && !date) dateTimeString = `${formatDateToYMD(toDate)}T23:59`

      to = new Date(dateTimeString)
    }
    
    setValidationError(validateDateRange(from, to))

    // Apply changes
    if (changed === 'from') {
      setFromDate(from)
      setFromTime(from.toTimeString().substring(0,5))
      onFromChange(from)
    }
    else if (changed === 'to') {
      setToDate(to)
      setToTime(to.toTimeString().substring(0,5))
      onToChange(to)
    }
  }

  return (
    <div>
      <div className={`flex ${deviceState.isMobile ? 'gap-4' : 'flex-col'}`}>
        <div className='select-none md:mt-2'>
          <label htmlFor='fromDate' className='inline-block mb-1'>Startdatum</label>
          <InputDate
            onDateChange={(date) => handleDateTimeChange({ changed: 'from', date })}
            date={fromDate}
            onTimeChange={(time) => handleDateTimeChange({ changed: 'from', time })}
            withTime={true}
            time={fromTime || '00:00'}
            ariaLabel="fromDate"
            id='fromDate'
            name='fromDate'
            isToDate = {false} />
        </div>
          
        <div className='select-none md:mt-2 '>

          <label htmlFor='toDate' className='inline-block mb-1'>Slutdatum</label>
          <InputDate
            onDateChange={(date) => handleDateTimeChange({ changed: 'to', date })}
            date={toDate}
            onTimeChange={(time) => handleDateTimeChange({ changed: 'to', time })}
            withTime={true}
            time={toTime || '23:59'}
            ariaLabel="toDate"
            id='toDate'
            name='toDate'
            isToDate = {true} />
        </div>
      </div> 
      {validationError &&
        <IcaAlertMessage alarmtype="failure" text="Startdatum kan inte vara större än slutdatum." persistencetype="persistent" noclose={true} />
      }
    </div>
  )
}
